"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.suggestions.title': 'AI 提示词优化',
    'ai.suggestions.description': '选择一个或多个建议插入到您的提示词中进行审查。然后您可以手动编辑和提交。',
    'ai.suggestions.apply': '应用建议',
    'ai.suggestions.clarification': '额外说明',
    'ai.suggestions.clarification.label': '额外说明（可选）',
    'ai.suggestions.clarification.placeholder': '添加具体要求或上下文...',
    'ai.suggestions.context.prompt': '来自输入',
    'ai.suggestions.context.message': '最后消息',
};
